/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles, 
    Theme, 
    TextField, 
    MenuItem, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Checkbox,
    Switch,
    IconButton } from '@material-ui/core';

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";    

import { purple } from '@material-ui/core/colors';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import LoadingOverlay from '../components/common/LoadingOverlay';

import PageContainer from '../components/layout/PageContainer';
import PageToolbar from '../components/layout/PageToolbar';
import PageBody from '../components/layout/PageBody';

import DataTable from '../components/table/DataTable';
import Button from '../components/common/Button';

import AddIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import SettingsIcon from '@material-ui/icons/Settings';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import RefreshIcon from '@material-ui/icons/Refresh';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AccountTreeOutlinedIcon from '@material-ui/icons/AccountTreeOutlined';
import ListOutlinedIcon from '@material-ui/icons/ListOutlined';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        // padding: theme.spacing(2),
    },
    dialogRoot: {
        '& .MuiPaper-root': {
            backgroundColor: theme.palette.text.primary,
        }
    },
    dialogTitle: {
        padding: '10px 24px 0px 24px',
        color: '#00000094'
    },
    dialogContent: {
        minHeight: '50vh',
        color: '#00000094',
        // padding: '20px',
        // display: 'flex',
        // alignItems: 'flex-start',
        // justifyContent: 'flex-start',
        // flexDirection: 'column'
    },
    textField: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(3,1,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    switchField: {
        display: 'flex', 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: theme.palette.text.secondary,
        marginRight: 10
    },    
    selectField: {
        width:  '500px',
        margin: theme.spacing(3,1,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    row: {
        display: 'flex', 
        flexDirection: 'row'
    },
    treeContainer: {
        margin: theme.spacing(0),
        padding: theme.spacing(2),
        borderRadius: '8px',
        backgroundColor: '#F8F9FA',
        color: theme.palette.text.secondary,
        // boxShadow: '0 8px 16px 0 rgba(0,0,0,0.14)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        minHeight: '80vh',
        height: '80vh',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            backgroundColor: '#F8F9FA',
            width:'12px'          
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor:'#F8F9FA'
        },        
        '&::-webkit-scrollbar-thumb': {
          backgroundColor:'#cecece',
          borderRadius:'16px',
          border:'2px solid #F8F9FA'
        },        
        '&::-webkit-scrollbar-button': {display: 'none'}

    },
    toolbar: {
        display: 'flex', 
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between'        
    },
    section: {
        display: 'flex', 
        flexDirection: 'row',
        width: '500px',
        justifyContent: 'flex-end',
        marginTop: '10px'        
    },
    list: {
        width: 'calc(100% - 0px)',
        backgroundColor: theme.palette.text.primary,
    },         
    listItem: {
        margin: '0px',
        padding: '5px 0px'
    },
    checkbox: {
        margin: '0px',
        padding: '0px'
    },
    listItemText: {
        margin: '0px',
        padding: '0px'
    },
    dialogActions: {
        '& .MuiButton-contained.Mui-disabled': {
            color: theme.palette.grey[300],
            border: '1px solid' 
        }
    },
    buttonPurple: {
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
            backgroundColor: purple[700],
        },
            padding: '5px 5px'
    },
    treeView: {
        height: '70vh',
        backgroundColor: '#fff',
        marginTop: '20px',
        borderRadius: '8px',
        padding: '10px',
        color: '#515151',
        fontWeight: 800        
    },
    treeItemContainer: {
        display: 'flex', 
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },    
    treeItem: {
        // '& .MuiFormControlLabel-root': {
        //     marginLeft: '-5px'
        // },
        '& .MuiButtonBase-root': {
            padding: '3px 5px'
        },        
        // '& .MuiTypography-root.MuiTreeItem-label.MuiTypography-body1': {
        //     backgroundColor: '#ffffff !important',
        // },
        // '& .MuiTreeItem-root.Mui-selected': {
        //     '& .MuiTreeItem-label': {
        //         backgroundColor: '#ffffff !important',
        //     },
        // },
        // '& .MuiFormControlLabel-root.Mui-disabled': {
        //     '& span': {
        //         color: theme.palette.grey[300]
        //     }
        // }
    }         
}));


const Profiles = () => {
    const history = useHistory();    
    const classes = useStyles();
    const { applicationSearchText, setApplicationSearchText, showSuccessMessage, showErrorMessage } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);
    const { profilesData, profilesManagement } = useContext(SecurityContext)
    const [isLoading, setLoading] = useState(true);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [currentSettings, setCurrentSettings] = useState(null);
    const [ownerProfiles, setOwnerProfiles] = useState([]);
    const [listRoles, setListRoles] = useState([]);
    const [action, setAction] = useState(null);
    const [isTreeViewMode, setTreeViewMode] = useState(true);
    const [treeData, setTreeData] = useState<RenderTree[]>([]);
    const [selectApp, setSelectApp] = useState(null);
    const [toogleLabel, setToogleLabel] = useState(true);

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);


    useEffect(() =>  {
        init();
    }, []);

    const init = () => {
        setLoading(true);        
        profilesManagement({init: true}).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });
    };

    useEffect(() =>  {
       if (profilesData.tableData) {
            const list = JSON.parse(JSON.stringify(profilesData.tableData));
            const treeRoot: RenderTree[] = [];
            const profile = list.find(profile => profile.applicationId === selectApp && profile.id === profile.ownerId);
            if (profile) {
                const root = { id: profile.id, name: toogleLabel ? profile.label : profile.name, disabled: profile.disabled, children: [] }
                loadTreeChild(root, list, selectApp);    
                treeRoot.push(root);                        
            }
            setTreeData(treeRoot);
        }    
    }, [profilesData, selectApp, toogleLabel]);

    const loadTreeChild = (node: RenderTree, list, appId) => {
        const profiles = list.filter(x => x.applicationId === appId && x.id !== node.id && x.ownerId === node.id).sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase()) ? 1 : -1);
        for (const profile of profiles) {
            const child = { id: profile.id, name: toogleLabel ? profile.label : profile.name, disabled: profile.disabled, children: [] };
            loadTreeChild(child, list, appId);
            node.children.push(child);
        }
    }

    const handleAppChange = (event: React.ChangeEvent<HTMLInputElement>) => {       
        setSelectApp(event.target.value);
    }; 

    const handleClickNew = () => {
        const record = {applicationId: profilesData.applicationData.applications[0].id};
        loadApplicationSettings(record, 'New');
        setCurrentRecord(record);
        setAction('New');
   };

    const handleClickTreeNew = (rowData) => {
        const obj = profilesData.tableData.find(x => x.id === rowData.id);
        const record = {applicationId: obj.applicationId, ownerId: obj.id};
        loadApplicationSettings(record, 'TreeNew');
        setCurrentRecord(record);
        setAction('Edit');
    };

    const handleClickEdit = (event, rowData) => {
        const record = profilesData.tableData.find(x => x.id === rowData.id);
        loadApplicationSettings(record, 'Edit');
        setCurrentRecord(record);
        setAction('Edit');
    };    

    const handleClickDelete = (event, rowData) => {
        setAction('Delete');
        setCurrentRecord(rowData);
    };    

    const handleClickClose = () => {
        setAction(null);
        setOwnerProfiles([]);
        setListRoles([]);
        setCurrentRecord(null);        
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        record[event.target.name] = event.target.value;
        setCurrentRecord(record);
    };        

    const handleApplicationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        record.applicationId = event.target.value;
        loadApplicationSettings(record, action);
        setCurrentRecord(record);
    };      

    const handleProfileOwnerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        record.ownerId = event.target.value;
        loadApplicationProfiles(record, ownerProfiles, action);
        setCurrentRecord(record);
    };  

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setToogleLabel(event.target.checked);
    };     

    const doClickDelete = () => {
        setLoading(true);            
        profilesManagement({ delete: currentRecord.id }).then(() => {
            showSuccessMessage('Profile delete success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      

    const doClickSave = () => {
        setLoading(true);
        const saveRecord = {
            id: currentRecord.id,
            name: currentRecord.name,
            label: currentRecord.label,
            application: currentRecord.applicationId,
            owner: currentRecord.ownerId,
            roles: []
        };
        loadRolesSelected(saveRecord.roles, listRoles);
        profilesManagement({ save: saveRecord }).then(() => {
            showSuccessMessage('Profile saved success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      

    const loadApplicationSettings = (record, action) => {
        setListRoles([]); 
        
        const ownerProfiles = JSON.parse(JSON.stringify(profilesData.tableData.filter(x => x.applicationId === record.applicationId)));
        
        if (action === 'New' && ownerProfiles.length > 0) {
            record.ownerId = ownerProfiles[0].id;
        }
        
        loadApplicationProfiles(record, ownerProfiles, action);
        setOwnerProfiles(ownerProfiles);
    }  

    const loadApplicationProfiles = (record, ownerProfiles, action) => {
        setListRoles([]); 
    
        let obj = ownerProfiles.find(x => x.id === record.ownerId);
        if (action === 'Edit' && record.id === record.ownerId) {
          obj = profilesData.applicationData.settings.find(x => x.id === record.applicationId);
        }
        
        const listRoles = [];
        const settings = obj ? JSON.parse(JSON.stringify(obj)).settings : [];
        for (const obj of settings) {
          const newObj = JSON.parse(JSON.stringify(obj));
          newObj.description = newObj.description ? newObj.description : newObj.name;
          const objExists = listRoles.find(x => x.id === newObj.id);
          if (!objExists) {
            listRoles.push(newObj);  
          } 
        }
        if (action === 'Edit') {
            loadRoles(listRoles, record.roles);
        }
        setListRoles(listRoles);
    }  

    const handleCheckRoles = (rowData: any) => () => {
        const list = [...listRoles];
        const role = list.find(x => x.id === rowData.id);
        role.checked = !role.checked;
        setListRoles(list);
    };
    
    const handleCheckSettings = (rowData: any) => () => {
        const newSettings = {...currentSettings};
        const role = newSettings.settings.find(x => x.id === rowData.id);
        role.checked = !role.checked;
        setCurrentSettings(newSettings);        
    };

    const handleClickSettings = (role: any) => () => {
        setCurrentSettings(role);
    };        

    const handleClickSettingsClose = () => {
        const rolesChecked = currentSettings.settings.filter(x => x.checked);
        if (!currentSettings.owner) {
            const role = listRoles.find(x => x.id === currentSettings.id);
            if (!role.checked && rolesChecked.length > 0) {
                role.checked = true;                
            }
            setListRoles(listRoles); 
            setCurrentSettings(null);   
        } else {
            const newSettings = {...currentSettings.owner};
            const role = newSettings.settings.find(x => x.id === currentSettings.id);
            if (!role.checked && rolesChecked.length > 0) {
                role.checked = true;                
            }
            setCurrentSettings(newSettings);
        }
    };

    const doClickSettingsFullAccess = () => {
        const newSettings = {...currentSettings};
        loadSettingsFullAccess(currentSettings.settings)
        setCurrentSettings(newSettings);        
    };      

    const loadSettingsFullAccess = (settings: any[]) => {
        for (const obj of settings) {
            obj.checked = true;
            if (obj.settings.length > 0) {
                loadSettingsFullAccess(obj.settings);
            }
        }
    };

    const loadRolesSelected = (roles, rolesSelected) => {
        for (const roleSelected of rolesSelected) {
            if (roleSelected.checked) {
                const role = { id: roleSelected.id, settings: [] };
                roles.push(role)
                if (roleSelected.settings && roleSelected.settings.length > 0) {
                    loadRolesSelected(role.settings, roleSelected.settings);
                }      
            }
        }
    }    

    const loadRoles = (roles, rolesSaved) => {
        for (const role of roles) {
          const roleSaved = rolesSaved.find(x => x.id === role.id);
          if (roleSaved) {    
            role.checked = true;
            if (roleSaved.settings && roleSaved.settings.length > 0) {
              loadRoles(role.settings, roleSaved.settings);
            }
          }  
        }
    }    
    
    const doClickRolesFullAccess = () => {
        const list = [...listRoles];
        loadSettingsFullAccess(list);
        setListRoles(list);        
    };      

    const renderTree = (nodes: RenderTree) => (
        <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        className={classes.treeItem}
        label={<div className={classes.treeItemContainer}>
            {nodes.name}
            <div>
                <IconButton color="secondary" onClick={() => handleClickTreeNew(nodes)} disabled={!currentUser.roles.PROFILE.SAVE_RECORD}>
                    <AddIcon />
                </IconButton>

                <IconButton color="primary" onClick={() => handleClickEdit(null, nodes)} disabled={!currentUser.roles.PROFILE.SAVE_RECORD}>
                    <EditIcon />
                </IconButton>

                <IconButton onClick={() => handleClickDelete(null, nodes)} disabled={!currentUser.roles.PROFILE.REMOVE_RECORD}>
                    <DeleteIcon color="error" />
                </IconButton>

            </div>
        </div>}
        >
        {Array.isArray(nodes.children)
            ? nodes.children.map(node => renderTree(node))
            : null}
        </TreeItem>
    );


    const renderTreeViewData = useMemo(() => <div className={classes.treeContainer}>
        <div className={classes.toolbar}>
            <TextField
                select
                label="Select an Application:"
                required
                placeholder="Applications"
                id="application"
                name="application"
                className={classes.selectField}
                style={{marginTop: '0px'}}
                value={selectApp}
                onChange={handleAppChange}                            
                fullWidth
                margin="dense"
                // variant="outlined"
                InputLabelProps={{shrink: true}}>
                    {   
                        profilesData?.applicationData?.applications?.map((app) => (
                            <MenuItem key={app.id} value={app.id}>
                                {toogleLabel ? app.label : app.description}                                                
                            </MenuItem>
                        ))                                    
                    }
            </TextField>
            <div className={classes.section}>
                <div className={classes.switchField}>
                    <Switch 
                        name="toogleLabel" 
                        checked={toogleLabel}
                        onChange={handleSwitchChange}  
                        color="primary" />
                    <b>View Short Name</b>
                </div>

                <Button size="small" color="primary" variant="contained" startIcon={<ListOutlinedIcon />}  onClick={() => setTreeViewMode(false)}>
                    Table View
                </Button>                
                <Button size="small" color="primary" variant="contained" startIcon={<RefreshIcon />}  onClick={() => {init()}}>
                    Refresh
                </Button>                
            </div>
        </div> 
        <TreeView
            className={classes.treeView}
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpanded={profilesData.tableData ? profilesData.tableData.map(x => x.id) : []}
            defaultExpandIcon={<ChevronRightIcon />}>
                { 
                    treeData?.map((item) => {
                        return renderTree(item);
                    })
                }
        </TreeView>
        <LoadingOverlay open={isLoading} />
    </div>, [profilesData, treeData, toogleLabel, isLoading]);

    const renderTableData = useMemo(() => <DataTable
        isLoading={action === null && isLoading}
        columns={[
            { title: 'Name', field: 'name' },
            { title: 'Label', field: 'label' },
            { title: 'Application', field: 'applicationName' }
        ]}
        data={JSON.parse(JSON.stringify(profilesData.tableData))}        
        actions={[
            {
                icon: () => <EditIcon color="primary" />,
                tooltip: 'Edit Profile',
                onClick: handleClickEdit,
                hidden: !currentUser.roles.PROFILE.SAVE_RECORD
            },
            {
                icon: () => <DeleteIcon color="error" />,
                tooltip: 'Delete Profile',
                onClick: handleClickDelete,
                hidden: !currentUser.roles.PROFILE.REMOVE_RECORD
            },
            {
                icon: () => <AccountTreeOutlinedIcon color="primary" />,
                tooltip: 'Tree View',
                onClick: (event) => setTreeViewMode(true),
                isFreeAction: true
            },
            {
                icon: () => <RefreshIcon color="primary" />,
                tooltip: 'Refresh',
                onClick: (event) => init(),
                isFreeAction: true
            }
        ]}              
    />, [profilesData, isLoading]);

    const renderListRoles = useMemo(() => <List dense={true} className={classes.list}>
        {listRoles.map((role) => {
            const labelId = `roles-list-label-${role.id}`;
            role.owner = null;
            return (
                <ListItem key={role.id} className={classes.listItem} role={undefined} dense={true} button onClick={handleCheckRoles(role)}>
                    <ListItemIcon>
                        <Checkbox
                            className={classes.checkbox}
                            edge="start"
                            checked={role.checked ? role.checked : false}
                            tabIndex={-1}
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                    </ListItemIcon>
                    <ListItemText id={labelId} className={classes.listItemText} primary={role.description} />
                    {role.settings && role.settings.length > 0 && <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="roles" onClick={handleClickSettings(role)}>
                            <SettingsIcon color="secondary" />
                        </IconButton>
                    </ListItemSecondaryAction>}
                </ListItem>
            );
        
        })}
    </List>, [listRoles, currentSettings]);

    const renderListSettings = useMemo(() => <List dense={true} className={classes.list}>
        {currentSettings && currentSettings.settings && currentSettings.settings.map((role) => {
            const labelId = `settigns-list-label-${role.id}`;
            role.owner = currentSettings;
            return (
                <ListItem key={role.id} className={classes.listItem} role={undefined} dense={true} button onClick={handleCheckSettings(role)}>
                    <ListItemIcon>
                        <Checkbox
                            className={classes.checkbox}
                            edge="start"
                            checked={role.checked ? role.checked : false}
                            tabIndex={-1}
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                    </ListItemIcon>
                    <ListItemText id={labelId}  className={classes.listItemText} primary={role.description} />
                    {role.settings && role.settings.length > 0 && <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="settings" onClick={handleClickSettings(role)}>
                            <SettingsIcon color="secondary"/>
                        </IconButton>
                    </ListItemSecondaryAction>}
                </ListItem>
            );
        
        })}
    </List>, [currentSettings]);

    return (
        <PageContainer className={classes.root}>
            <PageToolbar title="Profiles Management" backButton={true}>
                { !isTreeViewMode && currentUser.roles.PROFILE.SAVE_RECORD &&
                    <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={handleClickNew} >
                        New Profile
                    </Button>
                }
            </PageToolbar>
            <PageBody>
                { profilesData.tableData && !isTreeViewMode && renderTableData }
                { profilesData.tableData && isTreeViewMode && renderTreeViewData }
            </PageBody>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'New' || action === 'Edit'}
                aria-labelledby="save-dialog">
                <DialogTitle className={classes.dialogTitle} id="save-dialog">{action} Profile</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { currentRecord && <>
                        <div className={classes.row}>                        
                            <TextField
                                label="Name:"
                                required
                                placeholder="Name"
                                id="name"
                                name="name"
                                className={classes.textField}
                                error={currentRecord.name !== undefined && !currentRecord.name}
                                value={currentRecord.name}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />

                            <TextField
                                required
                                label="Label:"
                                placeholder="Label"
                                id="label"
                                name="label"
                                className={classes.textField}
                                error={currentRecord.label !== undefined && !currentRecord.label}
                                value={currentRecord.label}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                inputProps={{ maxLength: 30 }}
                                InputLabelProps={{shrink: true}}
                            />                            

                        </div>
                        <div className={classes.row}>                        
                            <TextField
                                select
                                label="Application:"
                                required
                                disabled={action === 'Edit'}
                                placeholder="Application"
                                id="applicationId"
                                name="applicationId"
                                className={classes.textField}
                                error={currentRecord.applicationId !== undefined && !currentRecord.applicationId}
                                value={currentRecord.applicationId}
                                onChange={handleApplicationChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}>
                                { 
                                    profilesData && profilesData.applicationData && profilesData.applicationData.applications && profilesData.applicationData.applications.map((application) => (
                                        <MenuItem key={application.id} value={application.id}>
                                            {application.description}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>

                            <TextField
                                select
                                label="Profile Owner:"
                                required
                                disabled={action === 'Edit'}
                                placeholder="Profile Owner"
                                id="ownerId"
                                name="ownerId"
                                className={classes.textField}
                                error={currentRecord.ownerId !== undefined && !currentRecord.ownerId}
                                value={currentRecord.ownerId}
                                onChange={handleProfileOwnerChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}>
                                { 
                                    ownerProfiles.map((profile) => (
                                        <MenuItem key={profile.id} value={profile.id}>
                                            {profile.name}
                                        </MenuItem>
                                    ))
                                }
                            </TextField>
                        </div>

                        {renderListRoles}

                    </> }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <Button  variant="contained" className={classes.buttonPurple} startIcon={<DoneAllIcon />} onClick={doClickRolesFullAccess} >
                        Full Access
                    </Button>
                    <div style={{flex: '1 0'}}></div>
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button disabled={currentRecord && (!currentRecord.name || !currentRecord.applicationId || !currentRecord.label || !currentRecord.ownerId)} variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSave} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="sm"
                open={action === 'Delete'}
                aria-labelledby="delete-dialog">
                <DialogTitle className={classes.dialogTitle} id="delete-dialog">{action} Profile</DialogTitle>
                <DialogContent dividers={false}>
                    <DialogContentText>
                        Do you want delete profile "{currentRecord && currentRecord.name}"? 
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button variant="contained" color="primary" startIcon={<DeleteIcon />} onClick={doClickDelete} >
                        Delete
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={currentSettings !== null}
                aria-labelledby="settings-dialog">
                <DialogTitle className={classes.dialogTitle} id="settings-dialog">
                    <IconButton color="primary" component="span" onClick={handleClickSettingsClose}>
                        <ArrowBackIcon />
                    </IconButton> 
                    Edit Settings: {currentSettings && currentSettings.description}
                </DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { renderListSettings }
                </DialogContent>
                <DialogActions>
                    <Button  variant="contained" className={classes.buttonPurple} startIcon={<DoneAllIcon />} onClick={doClickSettingsFullAccess} >
                        Full Access
                    </Button>
                    <div style={{flex: '1 0'}}></div>
                    {/* <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickSettingsClose}>
                        Close
                    </Button> */}
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>

        </PageContainer>
    );
};

export interface RenderTree {
    id: string;
    name: string;
    disabled: boolean;
    children?: RenderTree[];
}
 
export default Profiles;
